(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tc-floating-gallery"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var SECTION_TYPE = 'tc-floating-gallery';
  var USE_GSAP     = typeof gsap !== 'undefined';
  var REDUCED      = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Helpers ─────────────────────────────────────────────────── */
  function clamp(v, lo, hi) { return v < lo ? lo : v > hi ? hi : v; }

  /*
   * Frame-rate-independent lerp.
   * factor is tuned for 60fps; dt normalises to actual frame time.
   */
  function lerpDt(a, b, factor, dt) {
    var t = 1 - Math.pow(1 - factor, dt / 16.667);
    return a + (b - a) * t;
  }

  /* ══════════════════════════════════════════════════════════════
     SECTION INIT
  ══════════════════════════════════════════════════════════════ */
  function initSection(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var canvas  = root.querySelector('.tc-floating-gallery__canvas');
    var itemEls = Array.from(root.querySelectorAll('.tc-float-item'));
    if (!canvas || !itemEls.length) return;

    var globalDriftSpeed   = parseFloat(root.dataset.driftSpeed)   || 1.0;
    var globalDriftAmount  = parseFloat(root.dataset.driftAmount)  || 12;
    /*
     * scroll_return_target: 'start' | 'end'
     * On scroll, images travel toward whichever target is set.
     */
    var scrollReturnTarget = root.dataset.scrollReturn || 'start';

    /* Cached canvas dimensions — only updated on resize */
    var cw = 0, ch = 0;
    function cacheSize() { cw = canvas.offsetWidth; ch = canvas.offsetHeight; }
    var resizeObserver = new ResizeObserver(function () { cacheSize(); });
    resizeObserver.observe(canvas);
    root._resizeObs = resizeObserver;

    /* ── Per-item state ────────────────────────────────────────── */
    var items = itemEls.map(function (el, idx) {
      var startX = parseFloat(el.dataset.startX)     || 10;
      var startY = parseFloat(el.dataset.startY)     || 10;
      var endX   = parseFloat(el.dataset.endX)       || startX + 20;
      var endY   = parseFloat(el.dataset.endY)       || startY + 10;
      var rot    = parseFloat(el.dataset.rotation)   || 0;
      var phase  = parseFloat(el.dataset.driftPhase) || (idx * 1.3);
      var amp    = parseFloat(el.dataset.driftAmp)   || globalDriftAmount;

      /*
       * Drift: instead of offsetting from a single anchor with a sine,
       * we lerp a "progress" value 0→1 back and forth between
       * startPx and endPx. The sine drives the progress oscillation.
       * This means the image genuinely travels between the two points.
       */
      var speed = (Math.PI * 2 / 10000) * globalDriftSpeed * (0.75 + (idx % 4) * 0.12);

      return {
        el:            el,
        /* Start/end in % — converted to px after first paint */
        startXpct:     startX,
        startYpct:     startY,
        endXpct:       endX,
        endYpct:       endY,
        startXpx:      0,
        startYpx:      0,
        endXpx:        0,
        endYpx:        0,
        rot:           rot,
        phase:         phase,
        speed:         speed,
        /*
         * Drift amplitude controls how much of the start→end range
         * the image actually sweeps. 1.0 = full range, 0.5 = half.
         * We map amp (0–40) to a 0–1 multiplier (default ~0.5).
         */
        driftMix:      clamp(amp / 40, 0, 1),
        /* Current rendered position */
        x:             0,
        y:             0,
        currentRot:    rot,
        targetRot:     rot,
        elapsed:       0,
        /* Drag momentum */
        vx:            0,
        vy:            0,
        dragging:      false,
        gliding:       false,
        glideDecay:    0.88,
        /*
         * scrollProgress: 0 = section fully in view, 1 = section scrolled past.
         * Used to lerp position toward the return target.
         */
        scrollProgress: 0,
      };
    });

    /* ── Set px positions from % after first paint ─────────────── */
    function setBasePx() {
      cacheSize();
      items.forEach(function (it) {
        it.startXpx = cw * it.startXpct / 100;
        it.startYpx = ch * it.startYpct / 100;
        it.endXpx   = cw * it.endXpct   / 100;
        it.endYpx   = ch * it.endYpct   / 100;
        /* Clamp so item stays inside canvas */
        var iw = it.el.offsetWidth;
        var ih = it.el.offsetHeight;
        it.startXpx = clamp(it.startXpx, 0, cw - iw);
        it.startYpx = clamp(it.startYpx, 0, ch - ih);
        it.endXpx   = clamp(it.endXpx,   0, cw - iw);
        it.endYpx   = clamp(it.endYpx,   0, ch - ih);
        /* Start at the start position */
        it.x = it.startXpx;
        it.y = it.startYpx;
        /* Anchor via left/top once — all motion via transform */
        it.el.style.left       = it.startXpx + 'px';
        it.el.style.top        = it.startYpx + 'px';
        it.el.style.transform  = 'translate3d(0px,0px,0) rotate(' + it.rot + 'deg)';
        it.el.style.willChange = 'transform, opacity';
      });
    }

    /* ── Float-in entrance ──────────────────────────────────────── */
    function floatIn() {
      if (REDUCED) {
        items.forEach(function (it) { it.el.style.opacity = '1'; });
        return;
      }
      if (USE_GSAP) {
        var ctx = gsap.context(function () {
          var tl = gsap.timeline({ paused: true });
          items.forEach(function (it, i) {
            tl.fromTo(it.el,
              { opacity: 0, scale: 0.82 },
              { opacity: 1, scale: 1, duration: 0.65, ease: 'back.out(1.4)' },
              i * 0.1
            );
          });
          root._tl = tl;
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
              if (e.isIntersecting) { tl.play(); io.disconnect(); }
            });
          }, { threshold: 0.1 });
          io.observe(root);
        }, root);
        root._gsapCtx = ctx;
      } else {
        items.forEach(function (it, i) {
          it.el.style.transition = 'opacity 0.5s ease ' + (i * 0.1) + 's';
          it.el.style.opacity    = '1';
        });
      }
    }

    /* ── ScrollTrigger — drives scrollProgress per item ─────────── */
    function initScrollTrigger() {
      if (!USE_GSAP || REDUCED) return;
      if (typeof ScrollTrigger === 'undefined') return;

      gsap.registerPlugin(ScrollTrigger);

      /*
       * One ScrollTrigger for the whole section.
       * scrub: true means the progress value mirrors scroll position 1:1.
       * start: "top bottom" = trigger when section top hits viewport bottom.
       * end:   "bottom top" = trigger when section bottom hits viewport top.
       */
      var st = ScrollTrigger.create({
        trigger: root,
        start:   'top bottom',
        end:     'bottom top',
        scrub:   true,
        onUpdate: function (self) {
          /*
           * self.progress: 0 when section enters from bottom,
           *                1 when section has fully scrolled past top.
           * We want items to return to target as the section leaves.
           * Map: 0–0.4 = entering (section in view, drift freely)
           *      0.4–1 = leaving (lerp toward return target)
           */
          var p = self.progress;
          var returnProgress = clamp((p - 0.4) / 0.6, 0, 1);
          items.forEach(function (it) {
            it.scrollProgress = returnProgress;
          });
        }
      });

      root._scrollTrigger = st;
    }

    /* ── RAF drift loop ─────────────────────────────────────────── */
    var rafId   = null;
    var running = false;
    var lastTs  = null;

    function tick(ts) {
      if (!running) return;
      rafId = requestAnimationFrame(tick);

      var dt = lastTs === null ? 16.667 : Math.min(ts - lastTs, 100);
      lastTs = ts;

      items.forEach(function (it) {
        if (it.dragging) return;

        /* ── Momentum glide ──────────────────────────────────────── */
        if (it.gliding) {
          it.vx   *= it.glideDecay;
          it.vy   *= it.glideDecay;
          /* Glide updates the start anchor so drift resumes from here */
          it.startXpx = clamp(it.startXpx + it.vx, 0, cw - it.el.offsetWidth);
          it.startYpx = clamp(it.startYpx + it.vy, 0, ch - it.el.offsetHeight);
          if (Math.abs(it.vx) < 0.08 && Math.abs(it.vy) < 0.08) {
            it.vx = 0; it.vy = 0; it.gliding = false;
          }
        }

        /* ── Drift between start and end ─────────────────────────── */
        it.elapsed += dt;
        var t = it.elapsed * it.speed;

        /*
         * sine oscillates -1 → +1. Map to 0 → 1 progress between start and end.
         * driftMix scales how far along the start→end vector the image travels.
         */
        var sinVal    = (Math.sin(t + it.phase) + 1) / 2; // 0→1
        var driftFrac = sinVal * it.driftMix;

        var driftTargetX = it.startXpx + (it.endXpx - it.startXpx) * driftFrac;
        var driftTargetY = it.startYpx + (it.endYpx - it.startYpx) * driftFrac;

        /* ── Scroll return override ───────────────────────────────── */
        /*
         * As scrollProgress rises (section leaving viewport),
         * we blend the drift target toward the return target position.
         * scrollProgress = 0: pure drift
         * scrollProgress = 1: fully at return target
         */
        var sp = it.scrollProgress;
        if (sp > 0) {
          var returnX = (scrollReturnTarget === 'end') ? it.endXpx : it.startXpx;
          var returnY = (scrollReturnTarget === 'end') ? it.endYpx : it.startYpx;
          driftTargetX = driftTargetX + (returnX - driftTargetX) * sp;
          driftTargetY = driftTargetY + (returnY - driftTargetY) * sp;
        }

        /* ── Smooth follow (frame-rate independent) ───────────────── */
        it.x = lerpDt(it.x, driftTargetX, 0.055, dt);
        it.y = lerpDt(it.y, driftTargetY, 0.055, dt);

        /* ── Rotation wobble ─────────────────────────────────────── */
        it.targetRot  = it.rot + Math.sin(t * 0.55 + it.phase) * 1.2;
        it.currentRot = lerpDt(it.currentRot, it.targetRot, 0.06, dt);

        /* ── Render via translate3d (GPU only, no layout) ────────── */
        var tx = it.x - it.startXpx;
        var ty = it.y - it.startYpx;
        it.el.style.transform =
          'translate3d(' + tx + 'px,' + ty + 'px,0) rotate(' + it.currentRot + 'deg)';
      });
    }

    function startLoop() {
      if (running) return;
      running = true;
      lastTs  = null;
      rafId   = requestAnimationFrame(tick);
    }

    function stopLoop() {
      running = false;
      lastTs  = null;
      if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
    }

    /* Run RAF only when section is in viewport */
    var visObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { e.isIntersecting ? startLoop() : stopLoop(); });
    }, { threshold: 0 });
    visObs.observe(root);
    root._visObs = visObs;

    /* ── Drag ────────────────────────────────────────────────────── */
    var topZ      = 100;
    var inEditor  = !!(window.Shopify && window.Shopify.designMode);

    function bringToFront(el) { topZ++; el.style.zIndex = topZ; }

    function startDrag(it, cx, cy) {
      var cRect  = canvas.getBoundingClientRect();
      var elRect = it.el.getBoundingClientRect();
      var offX   = cx - elRect.left;
      var offY   = cy - elRect.top;
      var prevCx = cx, prevCy = cy, prevTs = performance.now();

      it.dragging = true;
      it.gliding  = false;
      it.vx = 0; it.vy = 0;
      it.el.classList.add('is-dragging');
      bringToFront(it.el);

      function onMove(ncx, ncy) {
        var now = performance.now();
        var dt  = Math.max(now - prevTs, 1);
        it.vx   = (ncx - prevCx) / dt * 16.667;
        it.vy   = (ncy - prevCy) / dt * 16.667;
        prevCx  = ncx; prevCy = ncy; prevTs = now;

        var nx = clamp(ncx - cRect.left - offX, 0, cRect.width  - it.el.offsetWidth);
        var ny = clamp(ncy - cRect.top  - offY, 0, cRect.height - it.el.offsetHeight);

        /*
         * On drag, we relocate the start anchor to where the user dropped it.
         * End position stays where it was — so after dragging, the image
         * drifts between the new start and the original end.
         */
        it.startXpx = nx;
        it.startYpx = ny;
        it.x = nx;
        it.y = ny;
        it.el.style.left      = nx + 'px';
        it.el.style.top       = ny + 'px';
        it.el.style.transform = 'translate3d(0px,0px,0) rotate(' + it.rot + 'deg) scale(1.05)';
      }

      function endDrag() {
        it.dragging = false;
        it.gliding  = (Math.abs(it.vx) > 0.4 || Math.abs(it.vy) > 0.4);
        it.el.classList.remove('is-dragging');
        it.el.style.transform = 'translate3d(0px,0px,0) rotate(' + it.rot + 'deg)';
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup',   onMouseUp);
        document.removeEventListener('touchmove', onTouchMove, { passive: false });
        document.removeEventListener('touchend',  onTouchEnd);
      }

      function onMouseMove(e) { onMove(e.clientX, e.clientY); }
      function onMouseUp()    { endDrag(); }
      function onTouchMove(e) { e.preventDefault(); onMove(e.touches[0].clientX, e.touches[0].clientY); }
      function onTouchEnd()   { endDrag(); }

      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup',   onMouseUp);
      document.addEventListener('touchmove', onTouchMove, { passive: false });
      document.addEventListener('touchend',  onTouchEnd);
    }

    if (inEditor) {
      items.forEach(function (it) {
        it.el.style.cursor = 'default';
        it.el.setAttribute('title', 'Use the Position sliders in the sidebar to move this image');
      });
      var hint = root.querySelector('[data-drag-hint]');
      if (hint) hint.style.display = 'none';
    } else {
      items.forEach(function (it) {
        it.el.addEventListener('mousedown', function (e) {
          e.preventDefault(); startDrag(it, e.clientX, e.clientY);
        });
        it.el.addEventListener('touchstart', function (e) {
          e.preventDefault(); startDrag(it, e.touches[0].clientX, e.touches[0].clientY);
        }, { passive: false });

        it.el.addEventListener('keydown', function (e) {
          var STEP = 12, moved = true;
          switch (e.key) {
            case 'ArrowLeft':  it.startXpx -= STEP; break;
            case 'ArrowRight': it.startXpx += STEP; break;
            case 'ArrowUp':    it.startYpx -= STEP; break;
            case 'ArrowDown':  it.startYpx += STEP; break;
            default: moved = false;
          }
          if (moved) {
            e.preventDefault();
            it.startXpx = clamp(it.startXpx, 0, cw - it.el.offsetWidth);
            it.startYpx = clamp(it.startYpx, 0, ch - it.el.offsetHeight);
            bringToFront(it.el);
          }
        });
      });
    }

    /* ── Boot ───────────────────────────────────────────────────── */
    requestAnimationFrame(function () {
      setBasePx();
      floatIn();
      initScrollTrigger();
    });

    root._stopLoop = stopLoop;
  }

  /* ══════════════════════════════════════════════════════════════
     DESTROY
  ══════════════════════════════════════════════════════════════ */
  function destroySection(root) {
    if (!root) return;
    if (root._stopLoop)      root._stopLoop();
    if (root._gsapCtx)       root._gsapCtx.revert();
    if (root._visObs)        root._visObs.disconnect();
    if (root._resizeObs)     root._resizeObs.disconnect();
    if (root._scrollTrigger) root._scrollTrigger.kill();
    root.dataset.initialized = 'false';
  }

  /* ══════════════════════════════════════════════════════════════
     BOOTSTRAP
  ══════════════════════════════════════════════════════════════ */
  document.querySelectorAll('[data-section-type="' + SECTION_TYPE + '"]').forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-section-type="' + SECTION_TYPE + '"]');
    if (root) { destroySection(root); initSection(root); }
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target.querySelector('[data-section-type="' + SECTION_TYPE + '"]');
    if (root) destroySection(root);
  });
  document.addEventListener('shopify:section:select', function (e) {
    var root = e.target.querySelector('[data-section-type="' + SECTION_TYPE + '"]');
    if (root && root._tl) root._tl.progress(1);
  });
  document.addEventListener('shopify:block:select', function (e) {
    var item = e.target;
    if (item && item.classList.contains('tc-float-item')) item.style.zIndex = 9998;
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tc-keyword-cloud"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var SECTION_TYPE = 'tc-keyword-cloud';
  var USE_GSAP     = typeof gsap !== 'undefined';
  var REDUCED      = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function clamp(v, lo, hi) { return v < lo ? lo : v > hi ? hi : v; }
  function lerpDt(a, b, factor, dt) {
    var t = 1 - Math.pow(1 - factor, dt / 16.667);
    return a + (b - a) * t;
  }

  /* ══════════════════════════════════════════════════════════════
     SECTION INIT
  ══════════════════════════════════════════════════════════════ */
  function initSection(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var canvas        = root.querySelector('.tc-keyword-cloud__canvas');
    var pillEls       = Array.from(root.querySelectorAll('.tc-pill'));
    if (!canvas || !pillEls.length) return;

    var globalSpeed   = parseFloat(root.dataset.driftSpeed)       || 1.0;
    var spotlightMs   = (parseFloat(root.dataset.spotlightInterval) || 2.5) * 1000;
    /*
     * Font size range — the canvas maps cursor distance to this range.
     * Nearest pill → sizeMax, farthest pill → sizeMin.
     */
    /* Schema stores font sizes as integers where 10 = 1.0rem (÷10 to get rem).
     * Legacy saved values may be ×10 larger (e.g. 240 instead of 24) — clamp. */
    var rawMin  = parseFloat(root.dataset.sizeMin) || 10;
    var rawMax  = parseFloat(root.dataset.sizeMax) || 15;
    var sizeMin = Math.min(rawMin / 10, 1.2);   /* rem — hard cap 1.2rem */
    var sizeMax = Math.min(rawMax / 10, 1.8);   /* rem — hard cap 1.8rem */

    var cw = 0, ch = 0;
    function cacheSize() { cw = canvas.offsetWidth; ch = canvas.offsetHeight; }
    var resizeObs = new ResizeObserver(function () { cacheSize(); });
    resizeObs.observe(canvas);
    root._resizeObs = resizeObs;

    /* ── Per-pill state ─────────────────────────────────────────── */
    var pills = pillEls.map(function (el, idx) {
      var pctX     = parseFloat(el.dataset.posX)          || (8  + idx * 11) % 85;
      var pctY     = parseFloat(el.dataset.posY)          || (12 + idx * 19) % 82;
      var phase    = parseFloat(el.dataset.driftPhase)    || idx * 1.1;
      var amp      = parseFloat(el.dataset.driftAmp)      || 8;
      var speedMod = parseFloat(el.dataset.driftSpeedMod) || (0.7 + (idx % 5) * 0.12);
      var baseSize = (parseFloat(el.dataset.baseSize) || 10) / 10; /* rem — schema stores ×10, so 10→1.0rem */
      var speed    = (Math.PI * 2 / 9000) * globalSpeed * speedMod;

      return {
        el:           el,
        tooltip:      el.querySelector('.tc-pill__tooltip'),
        pctX: pctX, pctY: pctY,
        anchorX: 0,  anchorY: 0,
        x: 0,        y: 0,
        phase: phase, speed: speed,
        ampX: amp * 0.45, ampY: amp * 0.6,
        elapsed: 0,
        currentRot: 0, targetRot: 0,
        /* Font size state */
        baseSize:    baseSize,
        currentSize: baseSize,   /* smoothly interpolated each frame */
        targetSize:  baseSize,
        /* Interaction flags */
        hovered:     false,
        spotlighted: false,
      };
    });

    /* ── Set anchor positions ───────────────────────────────────── */
    function setAnchors() {
      cacheSize();
      pills.forEach(function (p) {
        var ax = cw * p.pctX / 100;
        var ay = ch * p.pctY / 100;
        p.anchorX = ax; p.anchorY = ay;
        p.x = ax;       p.y = ay;
        p.el.style.left       = ax + 'px';
        p.el.style.top        = ay + 'px';
        p.el.style.transform  = 'translate3d(0px,0px,0)';
        p.el.style.fontSize   = p.baseSize + 'rem';
        p.el.style.willChange = 'transform, opacity, font-size';
      });
    }

    /* ── Float-in entrance ──────────────────────────────────────── */
    function floatIn(onComplete) {
      if (REDUCED) {
        pills.forEach(function (p) { p.el.style.opacity = '0.45'; });
        if (onComplete) onComplete();
        return;
      }
      if (USE_GSAP) {
        var shuffled = pills.slice().sort(function () { return Math.random() - 0.5; });
        var tl = gsap.timeline({ onComplete: onComplete });
        shuffled.forEach(function (p, i) {
          tl.fromTo(p.el,
            { opacity: 0, scale: 0.6 },
            { opacity: 0.45, scale: 1, duration: 0.55, ease: 'back.out(1.5)' },
            i * 0.055
          );
        });
      } else {
        pills.forEach(function (p, i) {
          setTimeout(function () { p.el.style.opacity = '0.45'; }, i * 55);
        });
        setTimeout(function () { if (onComplete) onComplete(); }, pills.length * 55 + 300);
      }
    }

    /* ── Tooltip helpers ────────────────────────────────────────── */
    function showTooltip(p) {
      if (!p.tooltip || REDUCED) return;
      if (USE_GSAP) {
        gsap.killTweensOf(p.tooltip);
        gsap.fromTo(p.tooltip,
          { opacity: 0, y: 8 },
          { opacity: 1, y: 0, duration: 0.25, ease: 'power2.out' }
        );
      } else {
        p.tooltip.style.opacity = '1';
      }
    }

    function hideTooltip(p) {
      if (!p.tooltip) return;
      if (USE_GSAP) {
        gsap.killTweensOf(p.tooltip);
        gsap.to(p.tooltip, { opacity: 0, y: 5, duration: 0.18, ease: 'power2.in' });
      } else {
        p.tooltip.style.opacity = '0';
      }
    }

    /* ══════════════════════════════════════════════════════════════
       MOUSE TRACKING
    ══════════════════════════════════════════════════════════════ */
    /*
     * mouseX/Y: current cursor position relative to canvas.
     * mouseInside: false when cursor has left, so pills return to resting sizes.
     */
    var mouseX = -9999, mouseY = -9999, mouseInside = false;
    var idleTimer = null;

    canvas.addEventListener('mousemove', function (e) {
      var rect = canvas.getBoundingClientRect();
      mouseX = e.clientX - rect.left;
      mouseY = e.clientY - rect.top;
      mouseInside = true;
      /* Reset auto-spotlight idle timer on mouse activity */
      if (idleTimer) clearTimeout(idleTimer);
      idleTimer = setTimeout(function () {
        mouseInside = false;
      }, 2000); /* after 2s of no movement, treat as idle */
    });

    canvas.addEventListener('mouseleave', function () {
      mouseX = -9999; mouseY = -9999;
      mouseInside = false;
      if (idleTimer) clearTimeout(idleTimer);
    });

    /* ══════════════════════════════════════════════════════════════
       RAF LOOP
    ══════════════════════════════════════════════════════════════ */
    var rafId = null, running = false, lastTs = null;

    /* Pre-compute canvas diagonal once for distance normalisation */
    var canvasDiag = 1;
    function updateDiag() { canvasDiag = Math.sqrt(cw * cw + ch * ch) || 1; }

    function tick(ts) {
      if (!running) return;
      rafId = requestAnimationFrame(tick);
      var dt = lastTs === null ? 16.667 : Math.min(ts - lastTs, 80);
      lastTs = ts;

      /*
       * SIZE PASS — compute target font size for every pill based on
       * distance from cursor. Closest → sizeMax, farthest → sizeMin.
       * When mouse is absent, all return to their individual baseSize.
       */
      if (mouseInside) {
        /* Find closest and farthest pill to cursor for normalisation */
        var minDist = Infinity, maxDist = 0;
        pills.forEach(function (p) {
          var cx   = p.anchorX + p.el.offsetWidth  * 0.5;
          var cy   = p.anchorY + p.el.offsetHeight * 0.5;
          var dist = Math.sqrt((mouseX - cx) * (mouseX - cx) + (mouseY - cy) * (mouseY - cy));
          p._dist  = dist;
          if (dist < minDist) minDist = dist;
          if (dist > maxDist) maxDist = dist;
        });

        var distRange = maxDist - minDist || 1;

        pills.forEach(function (p) {
          if (p.hovered) {
            /* Hovered pill gets sizeMax */
            p.targetSize = sizeMax;
          } else {
            /*
             * Normalise 0 (closest) → 1 (farthest).
             * Map to sizeMax → sizeMin.
             * Non-linear curve (pow 0.6) keeps mid-range pills visible.
             */
            var norm = clamp((p._dist - minDist) / distRange, 0, 1);
            var curved = Math.pow(norm, 0.55);
            p.targetSize = sizeMax - (sizeMax - sizeMin) * curved;
          }
        });

      } else {
        /* Mouse absent — drift back to each pill's base size */
        pills.forEach(function (p) {
          p.targetSize = p.spotlighted ? (p.baseSize * 1.8) : p.baseSize;
        });
      }

      /* DRIFT + RENDER PASS */
      pills.forEach(function (p) {
        var speedScale = p.hovered ? 0.12 : 1.0;
        p.elapsed += dt * speedScale;
        var t  = p.elapsed * p.speed;
        var dx = Math.cos(t + p.phase)         * p.ampX;
        var dy = Math.sin(t + p.phase * 1.618) * p.ampY;

        /* Rotation wobble — subtle for text legibility */
        p.targetRot  = Math.sin(t * 0.4 + p.phase) * 0.5;
        p.currentRot = lerpDt(p.currentRot, p.targetRot, 0.05, dt);

        /* Magnetic mouse pull */
        var distX    = mouseX - (p.anchorX + p.el.offsetWidth  * 0.5);
        var distY    = mouseY - (p.anchorY + p.el.offsetHeight * 0.5);
        var dist     = Math.sqrt(distX * distX + distY * distY) || 1;
        var strength;
        if (p.hovered) {
          strength = 0.26;
        } else if (mouseInside) {
          strength = clamp(1 - dist / (canvasDiag * 0.55), 0, 1) * 0.06;
        } else {
          strength = 0;
        }

        var targetX = p.anchorX + dx + distX * strength;
        var targetY = p.anchorY + dy + distY * strength;
        var follow  = p.hovered ? 0.10 : 0.055;

        p.x = lerpDt(p.x, targetX, follow, dt);
        p.y = lerpDt(p.y, targetY, follow, dt);

        /* Smooth font size — snappier for hovered pill */
        var sizeFactor = p.hovered ? 0.14 : 0.07;
        p.currentSize  = lerpDt(p.currentSize, p.targetSize, sizeFactor, dt);

        /* GPU-only transform */
        var tx = p.x - p.anchorX;
        var ty = p.y - p.anchorY;
        p.el.style.transform = 'translate3d(' + tx + 'px,' + ty + 'px,0) rotate(' + p.currentRot + 'deg)';
        p.el.style.fontSize  = p.currentSize + 'rem';

        /* Opacity: closer pills are more opaque */
        if (mouseInside && !p.hovered) {
          var norm    = clamp((p._dist || 0) / (canvasDiag * 0.55), 0, 1);
          var opacity = 0.65 - norm * 0.45;  /* 0.65 near → 0.20 far */
          p.el.style.opacity = opacity;
        }
      });
    }

    function startLoop() {
      if (running) return;
      running = true; lastTs = null;
      updateDiag();
      rafId = requestAnimationFrame(tick);
    }
    function stopLoop() {
      running = false; lastTs = null;
      if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
    }

    var visObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { e.isIntersecting ? startLoop() : stopLoop(); });
    }, { threshold: 0 });
    visObs.observe(root);
    root._visObs = visObs;

    /* ══════════════════════════════════════════════════════════════
       AUTO-SPOTLIGHT CYCLE (when mouse is idle/absent)
    ══════════════════════════════════════════════════════════════ */
    var spotlightTimer = null;
    var cycleIdx       = 0;
    var spotlitPill    = null;

    function clearSpotlight() {
      if (spotlitPill) { spotlitPill.spotlighted = false; spotlitPill = null; }
    }

    function runNextSpotlight() {
      if (mouseInside) return; /* mouse active — skip */
      clearSpotlight();
      var p = pills[cycleIdx % pills.length];
      p.spotlighted = true;
      spotlitPill   = p;
      cycleIdx      = (cycleIdx + 1) % pills.length;
    }

    function startCycle() {
      if (spotlightTimer) clearInterval(spotlightTimer);
      setTimeout(function () {
        runNextSpotlight();
        spotlightTimer = setInterval(runNextSpotlight, spotlightMs);
      }, 600);
    }

    function stopCycle() {
      if (spotlightTimer) { clearInterval(spotlightTimer); spotlightTimer = null; }
      clearSpotlight();
    }
    root._stopCycle = stopCycle;

    /* ══════════════════════════════════════════════════════════════
       HOVER INTERACTION
    ══════════════════════════════════════════════════════════════ */
    pills.forEach(function (p) {
      p.el.addEventListener('mouseenter', function () {
        p.hovered = true;
        clearSpotlight();
        p.el.classList.add('is-hovered');
        showTooltip(p);
      });

      p.el.addEventListener('mouseleave', function () {
        p.hovered = false;
        p.el.classList.remove('is-hovered');
        hideTooltip(p);
        /* Restore resting opacity — RAF size loop handles the rest */
        if (USE_GSAP && !REDUCED) {
          gsap.to(p.el, { opacity: 0.45, duration: 0.25, ease: 'power2.out' });
        } else {
          p.el.style.opacity = '0.45';
        }
      });

      p.el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (p.hovered) {
            p.el.dispatchEvent(new MouseEvent('mouseleave'));
          } else {
            p.el.dispatchEvent(new MouseEvent('mouseenter'));
          }
        }
      });
    });

    /* ── Boot ───────────────────────────────────────────────────── */
    requestAnimationFrame(function () {
      setAnchors();
      updateDiag();
      floatIn(function () { startCycle(); });
    });
  }

  /* ══════════════════════════════════════════════════════════════
     DESTROY
  ══════════════════════════════════════════════════════════════ */
  function destroySection(root) {
    if (!root) return;
    if (root._stopCycle)  root._stopCycle();
    if (root._visObs)     root._visObs.disconnect();
    if (root._resizeObs)  root._resizeObs.disconnect();
    root.dataset.initialized = 'false';
  }

  /* ══════════════════════════════════════════════════════════════
     BOOTSTRAP
  ══════════════════════════════════════════════════════════════ */
  document.querySelectorAll('[data-section-type="' + SECTION_TYPE + '"]').forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-section-type="' + SECTION_TYPE + '"]');
    if (root) { destroySection(root); initSection(root); }
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target.querySelector('[data-section-type="' + SECTION_TYPE + '"]');
    if (root) destroySection(root);
  });
  document.addEventListener('shopify:section:select', function (e) {
    var root = e.target.querySelector('[data-section-type="' + SECTION_TYPE + '"]');
    if (root && root._stopCycle) root._stopCycle();
  });

})();

  } catch(e) { console.error(e); }
})();
})();
